// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__1O0TZ","textLARGE":"Text_textLARGE__1Gtix","textSMALL":"Text_textSMALL__1TWY_","textBOLD":"Text_textBOLD__3Xbyq","textCaps":"Text_textCaps__duXHd"};